import type { SurveyQuestion } from '../types/Survey.type';

/**
 * A survey "has conditional logic" when at least one question branches on a
 * prior answer via `if` / `ifSome`. Such surveys have a moving question total
 * (answers reveal or hide later questions), which makes a numeric progress
 * count ("12 / 67") jump around and mislead patients — so callers use this to
 * suppress the count while keeping the progress bar (Monday 12560530217).
 */
export const surveyHasConditionalLogic = (questions?: SurveyQuestion[]): boolean =>
  !!questions?.some(q => (q?.if?.length ?? 0) > 0 || (q?.ifSome?.length ?? 0) > 0);
